// TriggerPrivateNotificationModal.jsx
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { TranslationNamespace } from '../resource/translationNamespace.js';
import { ButtonId } from '../resource/mixpanel.js';
import { NULL_FUNCTION } from '../resource/defaults.js';
import { ASIDE_WIDTH } from '../resource/liveStreamConstants.js';

import media from '../style/media.js';
import FadeOut from '../style/FadeOut.js';
import FadeIn from '../style/FadeIn.js';

export const TriggerPrivateNotificationModal = ({
  status = '',
  id = '',
  titleI18nKey = '',
  body = null,
  button = null,
  isOnDesktop = false,
  modalId = '',
  close = NULL_FUNCTION,
}) => {
  const { t } = useTranslation();
  const onClickConfirm = () => {
    close({ id });
  };
  return (
    <Wrapper $status={status} $isOnDesktop={isOnDesktop}>
      <StyledTriggerPrivateNotificationModal>
        <Header>
          <HeaderText>
            {t(titleI18nKey, { ns: TranslationNamespace.LIVESTREAM })}
          </HeaderText>
        </Header>
        <Body>
          <div>{body}</div>
          {button || (
            <ConfirmButton
              type="button"
              data-element_id={ButtonId.All.ButtonConfirm}
              data-tracking_payload={{
                modalId,
              }}
              onClick={onClickConfirm}
            >
              {t('general_confirm', { ns: TranslationNamespace.LIVESTREAM })}
            </ConfirmButton>
          )}
        </Body>
      </StyledTriggerPrivateNotificationModal>
    </Wrapper>
  );
};

TriggerPrivateNotificationModal.propTypes = {
  status: PropTypes.string,
  id: PropTypes.string,
  titleI18nKey: PropTypes.string,
  body: PropTypes.node,
  button: PropTypes.node,
  isOnDesktop: PropTypes.bool,
  modalId: PropTypes.string,
  close: PropTypes.func,
};

const Wrapper = styled.div`
  width: ${({ $isOnDesktop }) =>
    $isOnDesktop ? `calc(100% - ${ASIDE_WIDTH}px)` : '100%'};
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: 0.6s forwards
    ${({ $status }) => ('closing' === $status ? FadeOut : FadeIn)};
`;

const StyledTriggerPrivateNotificationModal = styled.div`
  display: flex;
  min-width: 328px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border-radius: 4px;
  background: #232323;
`;

const Header = styled.div`
  display: flex;
  height: 36px;
  padding: 0px 16px;
  justify-content: center;
  align-items: center;
  background: #474747;
  width: 100%;
  border-radius: 4px 4px 0 0;
`;

const HeaderText = styled.div`
  color: white;
  text-align: center;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 22.5px */
  letter-spacing: 0.015px;
  font-size: 16px;
  ${media.mobile`
    font-size: 14px;
  `}
`;

const Body = styled.div`
  display: flex;
  padding: 0 16px 16px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const ConfirmButton = styled.button`
  display: flex;
  height: 40px;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid white;

  color: white;
  font-weight: 600;
  line-height: 150%; /* 30px */
  letter-spacing: 0.02px;
  font-size: 20px;
  ${media.mobile`
    font-size: 18px;
  `}
`;

export default TriggerPrivateNotificationModal;
